import React from "react";
import { Box } from "./box";

export const Display = props => {
  return <Box Component="h1" font="display" color="scribble" {...props} />;
};

export const Header = props => {
  return <Box Component="h2" font="header" {...props} />;
};

export const SubHeader = props => {
  return <Box Component="h3" font="subHeader" {...props} />;
};

export const Paragraph = props => {
  return <Box Component="p" font="paragraph" {...props} />;
};
